export default async ({ $api, app, $cookies, redirect, store }) => {
  const fail = () => {
    redirect(302, app.localePath('/compare-home-insurance/'));
  };
  const uuid = $cookies.get('bonkers-ie-home-insurance-order');
  if (!uuid) {
    return fail();
  }
  await $api(`protection/home_insurance_orders/${uuid}`).then(order => {
    store.commit('order/set', order);
  }).catch(e => {
    fail();
  });
};
